import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "", light = false }) => (
  <div className={`inline-flex items-center gap-2 ${className}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-brand-orange" />
    <span className={`font-display text-xs font-600 uppercase tracking-[0.2em] ${light ? "text-brand-orange" : "text-brand"}`}>
      {children}
    </span>
  </div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, className = "" }) => (
  <div className={`${center ? "mx-auto text-center" : ""} max-w-2xl ${className}`}>
    {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
    <h2 className="font-display text-3xl font-800 leading-tight tracking-tight text-brand-navy sm:text-4xl lg:text-[2.7rem]">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">{subtitle}</p>}
  </div>
);

export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="relative overflow-hidden bg-brand-navy pt-32 pb-16">
    <div className="absolute inset-0 dot-grid opacity-30" />
    <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand-orange/20 blur-3xl" />
    <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-brand-light/20 blur-3xl" />
    <div className="container-page relative">
      {eyebrow && <Eyebrow light className="mb-4">{eyebrow}</Eyebrow>}
      <h1 className="max-w-3xl font-display text-4xl font-800 leading-tight tracking-tight text-white sm:text-5xl">
        {title}
      </h1>
      {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-blue-100/90 sm:text-lg">{subtitle}</p>}
    </div>
  </section>
);
